/**
 * Which matched job pays into each of a person's group RRSP accounts, as the engine links them on save
 * (`_link_group_rrsps` in abi/merge/questionnaire.py): the user's choice, else one unlinked match and one
 * free account are linked. Used to say so on the account and to ask only when it's ambiguous.
 */
export type MatchedJob = { uuid: string; label: string; groupRrspUuid?: string };

export function groupRrspLinks(accounts: string[], jobs: MatchedJob[]): Map<string, MatchedJob> {
  const links = new Map<string, MatchedJob>();
  for (const j of jobs)
    if (j.groupRrspUuid && accounts.includes(j.groupRrspUuid)) links.set(j.groupRrspUuid, j);
  const unlinked = jobs.filter((j) => !j.groupRrspUuid || !accounts.includes(j.groupRrspUuid));
  const free = accounts.filter((a) => !links.has(a));
  if (unlinked.length === 1 && free.length === 1) links.set(free[0], unlinked[0]);
  return links;
}

/** Whether to ask which account a match goes into: more than one account, or more than one match. */
export const groupRrspChoiceNeeded = (accounts: number, matchedJobs: number) =>
  accounts >= 2 || (accounts >= 1 && matchedJobs >= 2);
